import React from 'react';
import { FormattedMessage } from 'react-intl';
import ClientInfo from './ClientInfo';

export const route = {
  path: '/clients/:slug',
  title: () => <FormattedMessage id="client.summary" />,
  component: ClientInfo
};
